/* eslint-disable */
import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import "./customFilter.css";
const FILTER_FUNCTIONS = {
	contains: "contains",
	not_contains: "not_contains",
	equals: "equals",
	not_equals: "not_equals",
	starts_with: "starts_with",
	ends_with: "ends_with"
};

export default forwardRef((props, ref) => {
	const [filterText, setFilterText] = useState(null);
	const [filterType, setFilterType] = useState(FILTER_FUNCTIONS.starts_with);
	const [search, setSearch] = useState(false);
	const inputRef = useRef(null);
	const selectRef = useRef(null);
	const { schema, setPayloadSchema, functionToBePassed, setParentSchema } =
		props.frameworkComponentWrapper.agGridReact.props.frameworkComponents;

	useImperativeHandle(ref, () => {
		return {
			getModel() {
				return filterText;
			},

			setModel(model) {
				setFilterText(model);
			},

			myMethodForTakingValueFromFloatingFilter(value) {
				setFilterText(value);
			},

			handleSearch() {
				setSearch(true);
			}
		};
	});

	const onInputBoxChanged = useDebouncedCallback(async (event) => {
		if (event.target.value) setFilterText(event.target.value);
		else setFilterText("");
	}, 3000);

	const onSelectChanged = (event) => {
		setFilterType(event.target.value);
	};

	useEffect(() => {
		if (filterText === null || props.column.colDef.field === null || filterType === null || !search) {
		} else {
			if (inputRef.current) {
				inputRef.current.value = filterText;
			}
			if (selectRef.current) {
				selectRef.current.value = filterType;
			}
			props.filterChangedCallback();
			//console.log("Data: ", props.column.colDef.field, filterText, filterType);
			setPayloadSchema({
				...schema,
				[props.column.colDef.field]: { value: filterText, type: filterType }
			});
			setSearch(false);
			//functionToBePassed();
		}
	}, [filterText, filterType, functionToBePassed, props, schema, setPayloadSchema, search]);

	return (
		<div className="custom-ag-icon">
			<div style={{ padding: "4px" }} className="customFilter">
				<div className="filter-container">
					<select
						className="customFilterInput"
						ref={selectRef}
						style={{ margin: "4px 0 4px 0", padding: "0px" }}
						onInput={onSelectChanged}
					>
						{/* <option value={FILTER_FUNCTIONS.contains}>Contains</option>
					<option value={FILTER_FUNCTIONS.not_contains}>Not contains</option>
					<option value={FILTER_FUNCTIONS.equals}>Equals</option>
					<option value={FILTER_FUNCTIONS.not_equals}>Not equals</option> */}
						<option value={FILTER_FUNCTIONS.starts_with} selected>
							Starts with
						</option>
						{/* <option value={FILTER_FUNCTIONS.ends_with}>Ends with</option> */}
					</select>
					<b></b>
					<input
						className="customFilterInput"
						ref={inputRef}
						style={{ margin: "4px 0 4px 0" }}
						onInput={onInputBoxChanged}
						placeholder="Filter..."
					/>
				</div>
			</div>
		</div>
	);
});
